import React, { type PropsWithChildren, type ReactNode } from 'react';
import cn from 'classnames';

import * as styles from './styles.module.css';

export type TabBarItemArgs = {
  icon: ReactNode;
  text: string;
  isActive?: boolean;
  notificationSlot?: ReactNode;
  render?: ReactNode;
};

export type TabBarItemProps = React.ButtonHTMLAttributes<HTMLButtonElement> &
  TabBarItemArgs &
  React.RefAttributes<HTMLButtonElement>;

export const TabBarItem = React.forwardRef<HTMLButtonElement, TabBarItemProps>(
  ({ icon, text, isActive = false, notificationSlot, render, ...props }, ref) => {
    const content = (
      <>
        <div className={styles.iconContainer}>
          {icon}
          <div className={styles.slot}>{notificationSlot}</div>
        </div>
        <span className={styles.text}>{text}</span>
      </>
    );

    if (React.isValidElement(render)) {
      return React.cloneElement(render, {
        ...props,
        ...render.props,
        style: {
          ...props.style,
          ...render.props.style,
        },
        className: cn([
          props.className,
          render.props.className,
          cn(styles.item, isActive && styles.active),
        ]),
        children: content,
      }) as any;
    }

    return (
      <button
        {...props}
        ref={ref}
        className={cn(styles.item, isActive && styles.active, props.className)}
        type="button"
      >
        {content}
      </button>
    );
  }
);

export function TabBarContainer({ children }: PropsWithChildren<{}>) {
  return <div className={styles.tabBarContainer}>{children}</div>;
}
